export default __webpack_public_path__ + "static/media/course7.4cc82f60.webp";